<section class="a2p-analysis">
  @if (loading()) {
    <div class="a2p-analysis__loading" role="status" aria-live="polite">
      <div class="a2p-analysis__loading-header">
        <mat-icon class="a2p-analysis__trigger-icon">auto_awesome</mat-icon>
        <strong>{{ 'SMS_REGISTRATION.V2.ANALYSIS.LOADING.TITLE' | translate }}</strong>
      </div>
      @for (step of loadingSteps; track step; let i = $index) {
        @if (i <= loadingStep()) {
          <div class="a2p-analysis__loading-step">
            @if (i < loadingStep()) {
              <mat-icon class="a2p-analysis__loading-check">check_circle</mat-icon>
            } @else {
              <span class="a2p-analysis__loading-spinner" aria-hidden="true"></span>
            }
            <span>{{ step | translate }}</span>
          </div>
        }
      }
    </div>
  } @else {
    @if (!result()) {
      <div class="a2p-analysis__trigger">
        <div class="a2p-analysis__trigger-main">
          <mat-icon class="a2p-analysis__trigger-icon">auto_awesome</mat-icon>
          <div class="a2p-analysis__trigger-text">
            <span class="a2p-analysis__title-row">
              <strong>{{ 'SMS_REGISTRATION.V2.ANALYSIS.TITLE' | translate }}</strong>
              <glxy-badge size="small" class="a2p-analysis-beta">{{
                'SMS_REGISTRATION.V2.ANALYSIS.BETA' | translate
              }}</glxy-badge>
            </span>
            <div class="a2p-analysis__intro">{{ 'SMS_REGISTRATION.V2.ANALYSIS.INTRO' | translate }}</div>
          </div>
        </div>
        <button mat-stroked-button class="a2p-analysis__trigger-btn" (click)="analyse()">
          <mat-icon>auto_awesome</mat-icon>
          {{ 'SMS_REGISTRATION.V2.ANALYSIS.ANALYSE' | translate }}
        </button>
      </div>
    }

    @if (error()) {
      <glxy-alert type="error" size="small">
        {{ 'SMS_REGISTRATION.V2.ANALYSIS.ERROR' | translate }}
      </glxy-alert>
    }

    @if (result(); as analysis) {
      <mat-card
        class="a2p-analysis__summary"
        [class.a2p-analysis__summary--success]="!sortedItems().length"
        appearance="outlined"
      >
        <mat-card-content>
          <div class="a2p-analysis__summary-header">
            <h3 class="a2p-analysis__summary-title">{{ 'SMS_REGISTRATION.V2.ANALYSIS.SUMMARY_TITLE' | translate }}</h3>
            <button mat-stroked-button class="a2p-analysis__recheck" (click)="analyse()">
              <mat-icon>refresh</mat-icon>
              {{ 'SMS_REGISTRATION.V2.ANALYSIS.RECHECK' | translate }}
            </button>
          </div>

          <p class="a2p-analysis__headline">{{ analysis.output }}</p>

          @if (sortedItems().length) {
            <div class="a2p-analysis__counts">
              @if (counts().must_fix) {
                <glxy-badge color="red">
                  {{ counts().must_fix }} {{ 'SMS_REGISTRATION.V2.ANALYSIS.SEVERITY.MUST_FIX' | translate }}
                </glxy-badge>
              }
              @if (counts().recommended) {
                <glxy-badge color="yellow">
                  {{ counts().recommended }} {{ 'SMS_REGISTRATION.V2.ANALYSIS.SEVERITY.RECOMMENDED' | translate }}
                </glxy-badge>
              }
              @if (counts().other) {
                <glxy-badge color="grey">
                  {{ counts().other }} {{ 'SMS_REGISTRATION.V2.ANALYSIS.SEVERITY.OTHER' | translate }}
                </glxy-badge>
              }
            </div>
          } @else {
            <div class="a2p-analysis__no-issues">
              <mat-icon class="a2p-analysis__loading-check">check_circle</mat-icon>
              <span>{{ 'SMS_REGISTRATION.V2.ANALYSIS.NO_ISSUES' | translate }}</span>
            </div>
          }
        </mat-card-content>
      </mat-card>

      @for (item of sortedItems(); track $index) {
        <mat-card class="a2p-analysis__item a2p-analysis__item--{{ item.severity }}" appearance="outlined">
          <mat-card-content>
            <div class="a2p-analysis__item-header">
              <glxy-badge [color]="badgeColor(item.severity)" size="small">
                {{ severityLabelKey(item.severity) | translate }}
              </glxy-badge>
              <h4 class="a2p-analysis__item-title">{{ item.title }}</h4>
            </div>

            <p class="a2p-analysis__item-description">{{ item.description }}</p>

            @if (item.exampleWording) {
              <div class="a2p-analysis__example">
                <div class="a2p-analysis__example-header">
                  <span class="a2p-analysis__example-label">
                    {{ 'SMS_REGISTRATION.V2.ANALYSIS.EXAMPLE' | translate }}
                  </span>
                  <button
                    mat-icon-button
                    (click)="copyExample(item)"
                    [attr.aria-label]="'SMS_REGISTRATION.V2.ANALYSIS.COPY' | translate"
                  >
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
                <p class="a2p-analysis__example-text">{{ item.exampleWording }}</p>
              </div>
            }
          </mat-card-content>
        </mat-card>
      }
    }
  }
</section>
